module.exports = __webpack_public_path__ + "static/media/axon.79303c35.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/experiences/axon.png
// module id = 97
// module chunks = 0